import styled from 'styled-components'
import { BP } from 'resources/constants'

export const Wrapper = styled.div<any>`
  margin-right: 48px;

  ul {
    padding: 12px 0 0;
    margin: 0;
    list-style: none;
    display: flex;
    justify-content: flex-end;

    @media (max-width: ${BP.lg.min}) {
      flex-direction: column;
    }

    li {
      margin: 0 5px;

      @media (max-width: ${BP.lg.min}) {
        margin: 0;
      }

      a,
      span {
        ${props => props.theme.css.link};
        padding: 0 4px;
        text-decoration: none;
        ${props => props.isLivBrite ? `
          font-size: 18px;
        ` : `
          font-size: 14px;
        `}
        cursor: pointer;

        @media (max-width: ${BP.lg.min}) {
          padding: 0 !important;
          ${props => props.isLivBrite ? `
            font-size: 18px;
          ` : `
            font-size: 16px;
          `}
        }
      }

      &:last-child {
        a,
        span {
          font-weight: ${props => props.theme.font.default.bold};

          @media (max-width: ${BP.lg.min}) {
            font-weight: ${props => props.theme.font.default.light};
          }
        }
      }
    }
  }
`
